import { useParams } from 'react-router-dom';

import { RoleFormPage } from '@personnel/presentation/components/shared';

interface RoleEditParams {
  uuid: string;
}

/**
 * Role Edit Page
 *
 * Page for editing an existing role.
 * Wrapper component that delegates to RoleFormPage with mode='edit'.
 * Route: /roles/:uuid
 *
 * @returns {React.ReactElement} Role edit page component
 *
 * @example
 * // In router
 * <Route path="/roles/:uuid" component={RoleEditPage} />
 */
export const RoleEditPage = (): React.ReactElement => {
  const { uuid } = useParams<RoleEditParams>();

  return <RoleFormPage mode="edit" roleUuid={uuid} />;
};
